// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  height: 100%;
  background-color: var(--pageBackgroud) !important;
}

#root {
  height: 100%;
  background-color: var(--pageBackgroud);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* 设置全局nav样式 */
.adm-nav-bar {
  background-color: var(--pageBackgroud);
  color: rgba(34, 34, 34, 1);
  font-size: 18px;
  position: fixed !important;
  width: 100vw !important;
  z-index: 9 !important;
  top: 0;

}

.adm-input-element {
  font-size: 14px !important;
}

.adm-image-uploader-cell-delete {
  width: 20px !important;
  height: 20px !important;
  font-size: 12px !important;
}

.adm-image-uploader-cell-delete-icon {
  top: 4px !important;
  left: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE;aACW;AACb;;AAEA,cAAc;AACd;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,MAAM;;AAER;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n  height: 100%;\n  background-color: var(--pageBackgroud) !important;\n}\n\n#root {\n  height: 100%;\n  background-color: var(--pageBackgroud);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* 设置全局nav样式 */\n.adm-nav-bar {\n  background-color: var(--pageBackgroud);\n  color: rgba(34, 34, 34, 1);\n  font-size: 18px;\n  position: fixed !important;\n  width: 100vw !important;\n  z-index: 9 !important;\n  top: 0;\n\n}\n\n.adm-input-element {\n  font-size: 14px !important;\n}\n\n.adm-image-uploader-cell-delete {\n  width: 20px !important;\n  height: 20px !important;\n  font-size: 12px !important;\n}\n\n.adm-image-uploader-cell-delete-icon {\n  top: 4px !important;\n  left: 4px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
